import { Status } from './utils/constants.js'
import { Journey } from './journey.js'
import { copyToClipboard } from './utils/browser.js'
import { initializeGallerySlider, handleRefreshModal } from './utils/slick.js'
import {
    lazyLoadVideos,
    deferLoadVideos,
    handleToggleVideo,
    setupPlayPauseCoverVideo,
} from './utils/video.js'
import Screen from './utils/screen.js'
import { $body, isPageTemplate } from './utils/wp.js'
import { zoomImage } from './utils/image.js'
import { scrollToNext, ScrollToTop } from './utils/scroll.js'
import MenuTracker from './components/menu-tracker.js'
import {
    setupHoverDropdown,
    setupDropdownItemAnchor,
    initializeBSTooltips,
} from './utils/bootstrap.js'
import Timeline from './components/timeline.js'
import { toggleSocialIconList } from './utils/social.js'
import { pauseMediaOnHide } from './utils/media.js'
import Navbar from './components/navbar.js'
import { initializeStage as initializeBusStage } from './journey-bus.js'

//////
;(function ($) {
    ;('use strict')

    // Doc ready
    $(function () {
        if (Screen.mediaBreakpointUp(Screen.breakpoints.sm)) {
            const menuTracker = new MenuTracker()
        }

        // Initialize hover dropdowns
        document.querySelectorAll('[data-bs-toggle\\.hover="dropdown"]').forEach(setupHoverDropdown)

        // Setup dropdown menu anchor links
        document
            .querySelectorAll('#side-menu .dropdown-item[href*="#stage-"]')
            .forEach(setupDropdownItemAnchor)

        // Initialize Bootstrap tooltips
        $('[data-bs-toggle="tooltip"]').each(initializeBSTooltips)

        $('.btn-hashtag').on('click', function () {
            const btn = this
            copyToClipboard(btn.innerText)
                .then(() => {
                    const tooltipID = $(btn).attr('aria-describedby')
                    $(`#${tooltipID}`).addClass('copied')
                })
                .catch((err) => {
                    console.error('Error copying text to clipboard: ', err)
                })
        })

        $('#toggle-social-icon-list').on('click', toggleSocialIconList)

        // Pause audio/video/iframe when closing modal/accordion
        $('.modal, .accordion-collapse').on('hide.bs.modal hide.bs.collapse', pauseMediaOnHide)

        // Initialize the Scroll To Top functionality
        new ScrollToTop()

        // Zoom images animation
        $('.zoom').on('click', zoomImage)

        if ($body.hasClass('home')) {
            const $cover = $('#cover')

            const setupStageSelectorSwiper = () => {
                if (typeof Swiper !== 'undefined') {
                    new Swiper('.etapa-swiper', {
                        a11y: true,
                        grabCursor: true,
                        keyboard: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        breakpoints: {
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            992: { slidesPerView: 4 },
                        },
                    })
                }
            }
            setupStageSelectorSwiper()

            // Setup train animation
            const triggerTrainAnimation = () => {
                const train = document.querySelector('.train-animated')
                const sectionTitle = train.previousElementSibling
                const sectionHeader = train.closest('.section-header')
                train.style.transform = `translateX(${sectionTitle.offsetWidth}px)`

                // Trigger the animation in the next frame
                requestAnimationFrame(() => {
                    train.style.opacity = 1
                    train.style.transform = `translateY(-50%) translateX(${
                        sectionHeader.offsetWidth - train.offsetWidth
                    }px)`
                })
            }

            const onEnterJourney = (e) => {
                // Hide the cover
                $cover.fadeOut(400, function () {
                    $body.addClass('cover-hidden')
                    $cover.remove()
                    triggerTrainAnimation()
                })

                // Show main content and footer
                $('#main > .container, .site-footer').css('visibility', 'inherit')
            }

            if (window.location.hash === '#inici') {
                // Don't show the cover
                $body.addClass('cover-hidden')
                $cover.remove()
                triggerTrainAnimation()
            } else {
                // Hide everything except cover
                $('#main > .container, .site-footer').css('visibility', 'hidden')

                const enterJourney = document.getElementById('enter-journey')
                enterJourney.addEventListener('click', onEnterJourney, { once: true })
                enterJourney.classList.add('listening')

                // Check if the user clicked on the button before the even listener could be attached
                if (enterJourney.classList.contains('loading')) {
                    onEnterJourney()
                }
            }

            // Play/Pause background video on click of the cover
            setupPlayPauseCoverVideo()
        } else if (isPageTemplate('journey-template') || isPageTemplate('journey-bus-template')) {
            /** Set up Swiper sliders **/
            // Stage selector slider
            const stageSelectorSwiperEls = document.querySelectorAll('.swiper--stage-selector')
            stageSelectorSwiperEls.forEach((stageSelectorSwiperEl) => {
                new Swiper(stageSelectorSwiperEl, {
                    a11y: true,
                    grabCursor: true,
                    keyboard: true,
                    mousewheel: true,
                    slidesPerView: 1.5,
                    breakpoints: {
                        576: { slidesPerView: 2.5 },
                        768: { slidesPerView: 3.5 },
                        992: { slidesPerView: 3.75 },
                    },
                })
            })

            const journey = new Journey(ScrollTrigger, ScrollToPlugin)
            const $relatedPages = $('#related-pages')
            const $footer = $('.site-footer')
            const navbar = Navbar.getInstance()
            let initialized = false
            let journeyProgressTween, timelineST, stageSelectorST, relatedPagesST

            const initializeJourney = (stageID) => {
                if (typeof stageID === 'undefined') {
                    console.warn('Stage ID to initialize not provided')
                }

                // @todo: Remove bus code when not needed anymore
                if (isPageTemplate('journey-bus-template')) {
                    initializeBusStage(stageID, journey, stageSelectorST)
                } else {
                    journey.initializeSlides(stageID)
                    stageSelectorST = journey.showStageSelector()
                }
                // ScrollTrigger.refresh() // Doesn't seem to work here in some cases (already initialized stage)

                if (!initialized) {
                    // Track progress of journey
                    journeyProgressTween = gsap.to('.journey-progress', {
                        value: 100,
                        scrollTrigger: {
                            scrub: 0.5,
                            invalidateOnRefresh: true,
                        },
                    })

                    // Initialize the Timeline component
                    try {
                        const timeline = new Timeline()
                        timelineST = timeline.scrollTrigger // Save the ScrollTrigger instance for later use
                    } catch (error) {
                        console.error('Error initializing timeline:', error.message)
                    }
                }

                initialized = true
            }

            const toggleBtnVisibility = (btn, isActive) => {
                gsap.set(btn, {
                    autoAlpha: isActive ? 1 : 0,
                    attr: {
                        'aria-hidden': String(!isActive),
                    },
                })
            }

            const onLoadJourneyTemplate = (e) => {
                // Disable pointer events until the inline stage selector is pinned
                journey.$stageSelectorInline.addClass('disabled')

                // Set loaders on images with .lazyloading class
                const $lazyLoadedImgs = $('.step img.lazyload, .slide img.lazyload')
                $lazyLoadedImgs.each(function () {
                    $(this).after('<span class="loader"></span>')
                })

                // Lazy load video until it is visible in viewport
                lazyLoadVideos()

                // Defer video loading until page is loaded
                deferLoadVideos()

                //// Hide navbar on scroll down

                // Move up stage header on scroll down
                const headerAnimation = gsap.to('.stage-header', {
                    top: '-=32',
                    duration: 0.5,
                    ease: 'power2.in',
                    paused: true,
                })

                //// navbarST

                const $toggleVideo = $('[data-toggle="video"]')
                $toggleVideo.on('click', handleToggleVideo)
            }

            if (document.readyState === 'complete') {
                setTimeout(() => {
                    onLoadJourneyTemplate()
                }, 0)
            } else {
                $(window).on('load', onLoadJourneyTemplate)
            }

            $body.addClass('cover-hidden selector-visible')
            journey.$stageSelectorInitial.removeClass('disabled')

            // Check if a stage is present in the URL hash and initialize it
            const targetId = window.location.hash.slice(1)
            if (targetId && targetId.startsWith('stage-')) {
                setTimeout(() => {
                    journey.$stageSelectorInitial.find(`a[href="#${targetId}"]`).trigger('click')
                    history.replaceState(null, '', ' ')
                }, 0)
            }

            const $stageSelectorItems = $('.stage-selector-item__link')
            $stageSelectorItems.on('click', (event) => {
                event.preventDefault()
                const scrollTriggers = ScrollTrigger.getAll()
                const selectedStage = event.currentTarget

                // Disable further clicks on stage selector
                journey.$stageSelectors.addClass('disabled')

                // Get all stage selectors with the same target
                const selectedStageID = selectedStage.getAttribute('href')
                const selectedStageIdNumber = parseInt(selectedStageID.split('-').pop())
                const $selectedStageAll = journey.$stageSelectors
                    .find('.stage-selector-item')
                    .filter((i, el) => el.querySelector(`a[href="${selectedStageID}"]`))

                // Set loading status
                $selectedStageAll.attr('data-status', Status.LOADING.description)

                // Show stages, related pages and footer
                gsap.set(['.stage', selectedStageID, $footer], {
                    visibility: 'inherit',
                })

                // Disable all stages except the selected one
                const disabledStages = journey.getStages().filter((stage) => {
                    return stage.id !== selectedStageID
                })

                // Hide all stages except the selected one and related pages (@xvc)
                gsap.set([disabledStages, $relatedPages], {
                    display: 'none',
                })
                gsap.set(selectedStageID, {
                    display: 'block',
                })

                // If the selected stage is the last one, show related pages (@xvc)
                if (selectedStageIdNumber === $('.stage').length - 1) {
                    gsap.set($relatedPages, {
                        display: 'inherit',
                    })
                    $('#main > .stage-selector').hide()
                }

                // Disable all scroll triggers except the ones for the selected stage
                scrollTriggers.forEach((st) => {
                    const trigger = st.trigger

                    if (!trigger?.id) {
                        return
                    }

                    if (
                        trigger.id.startsWith('step-') ||
                        trigger.id.startsWith('slide-') ||
                        trigger.id.startsWith('stage-')
                    ) {
                        if (
                            trigger.id === `stage-${selectedStageIdNumber}` ||
                            trigger.id.startsWith(`step-${selectedStageIdNumber}`) ||
                            trigger.id.startsWith(`slide-${selectedStageIdNumber}`)
                        ) {
                            st.enable()
                        } else {
                            st.disable()
                        }
                    } else {
                        console.debug(`Unknown trigger: ${trigger}`)
                    }
                })

                // Wait for transitions to end before initializing journey (otherwise the transition gets interrupted)
                Promise.all(
                    selectedStage.getAnimations().map((animation) => animation.finished)
                ).then(() => {
                    // Execute this in the next tick so the loading animation can start
                    setTimeout(() => {
                        // Initialize GSAP animations for the current stage
                        initializeJourney(selectedStageIdNumber)

                        // Hide page header
                        gsap.to('.page-header', {
                            autoAlpha: 0,
                            duration: 1,
                            onComplete: () => {
                                $('.journey-cover').hide()
                                setTimeout(() => {
                                    ScrollTrigger.refresh() // @todo: For some reason the content's width is not calculated correctly the first time.

                                    // Fade in welcome text
                                    if (selectedStageIdNumber === 0) {
                                        gsap.fromTo(
                                            '.welcome-text',
                                            {
                                                autoAlpha: 0,
                                                scale: 0.75,
                                                xPercent: -50,
                                                yPercent: 0,
                                            },
                                            {
                                                autoAlpha: 1,
                                                scale: 1,
                                                yPercent: -50,
                                                duration: 1.5,
                                            }
                                        )
                                    }
                                }, 0)
                            },
                        })

                        // Hide stage selector
                        gsap.to(journey.$stageSelectors, {
                            autoAlpha: 0,
                            duration: 1,
                            onStart: () => {
                                // Scroll to the top of the stage so the start/end positions are calculated correctly
                                gsap.to(window, {
                                    duration: 0,
                                    scrollTo: 0,
                                    onComplete: () => {
                                        ScrollTrigger.refresh() // Refresh all scrolltriggers for the current stage
                                    },
                                })
                                $selectedStageAll.attr('data-status', Status.LOADED.description)
                                journey.enterStage(selectedStageIdNumber)
                            },
                            onComplete: () => {
                                $body.removeClass('selector-visible selector-visible--inline')
                                journey.$stageSelectorInitial.hide()

                                // Refresh progress, timeline, stage selector and related pages scrolltriggers
                                journeyProgressTween?.scrollTrigger.refresh()
                                timelineST?.refresh()
                                stageSelectorST?.refresh()
                                stageSelectorST?.enable()
                                relatedPagesST?.refresh()

                                // Set tabindex and focus on the selected stage
                                $(disabledStages).attr('tabindex', '-1')
                                $(selectedStageID).attr('tabindex', '0').trigger('focus')

                                // Scroll down a little bit to show the stage introduction
                                if (selectedStageIdNumber > 0) {
                                    gsap.to(window, {
                                        duration: 0.5,
                                        scrollTo: {
                                            y: 100,
                                            autoKill: true,
                                        },
                                        ease: 'power4',
                                    })
                                }

                                // Show inline stage selector
                                if (selectedStageIdNumber < journey.getStages().length) {
                                    gsap.set(journey.$stageSelectorInline, {
                                        autoAlpha: 1,
                                    })
                                }
                            },
                        })
                    }, 0)
                })
            })

            // Scroll to next step when clicking welcome text (scroll down icon not visible sometimes on iPhone)
            $('.welcome-text').on('click', () => {
                const $scrollDownIcon = $('.scroll-down[href="#step-0-2"]')
                $scrollDownIcon.trigger('click')
                $scrollDownIcon.tooltip('show')
            })

            // Scroll to next step when clicking icon
            $('[data-scroll="down"]').on('click', scrollToNext)

            // Initialitze gallery slick slider from modal
            $('.modal').one('shown.bs.modal', initializeGallerySlider)

            // Reposition gallery slick slider from modal on resize
            $('.modal').on('hidden.bs.modal', handleRefreshModal)

            // Make sure the video is 'activated' on iOS
            const $slideVideos = $('.slide-video video')
            $(document.documentElement).one('touchstart', function (e) {
                $slideVideos.each(function () {
                    const video = this
                    video.play()
                    video.pause()
                })
            })
        } else {
            // Any page except journey-template
            document.documentElement.classList.add('scroll-smooth')
        }
    }) // END Document Ready
})(jQuery)
